import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5619b513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-msg-box-root" }
const _hoisted_2 = { class: "pc-avatar-mgs-box" }
const _hoisted_3 = { class: "pc-avatar-mgs-box-title-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "头像选择", -1))
const _hoisted_5 = { class: "pc-avatar-mgs-box-body-content" }
const _hoisted_6 = { class: "pc-avatar-mgs-box-body-content-avatar-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "pc-avatar-msg-box-button-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-avatar-mgs-box" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "close-btn btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.avatars, (a) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([[{ active: _ctx.avatar === a }, `avatar${a}`], "avatar-item"]),
              key: a,
              onClick: ($event: any) => (_ctx.setAvatar(a))
            }, null, 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "btn-cancel btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "取消"),
        _createElementVNode("div", {
          class: "btn-confirm btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, "确定")
      ])
    ]),
    _hoisted_9
  ]))
}